import toDate from '../to-date';
import isSameDay from '../is-same-day';

export const isToday = (date: Date | number): boolean => {
  const formattedDate = toDate(date);

  return isSameDay(formattedDate, Date.now());
};

export default isToday;
